type InvoiceEntityType = '' | 'INDIVIDUAL' | 'BUSINESS' | 'TRUST';

type InvoiceParty = {
  entityType: InvoiceEntityType;
  firstName?: string;
  lastName?: string;
  mobile?: string;
  address?: string;
  suburb?: string;
  state?: string;
  postcode?: string;
  businessName?: string;
  businessNumber?: string;
  isDone?: boolean;
};

export const buildInvoicePartyPayload = <T extends InvoiceParty>(party: T) => {
  const { businessName, businessNumber, isDone, ...details } = party;
  void isDone;
  const isEntity =
    party.entityType === 'BUSINESS' || party.entityType === 'TRUST';
  const fullName = isEntity
    ? party.firstName?.trim()
    : [party.firstName, party.lastName].filter(Boolean).join(' ').trim();

  return {
    ...details,
    lastName: isEntity ? '' : party.lastName,
    phone: party.mobile,
    address: [party.address, party.suburb, party.state, party.postcode]
      .filter(Boolean)
      .join(', '),
    fullName,
    ...(isEntity && { businessName, businessNumber })
  };
};
